'use client'

import { notFound } from 'next/navigation'

import { GameIsAdminOnly } from 'app/components/GameIsAdminOnly'
import GameDescriptionPageViaBuilder from 'src/pageContainers/GameDescriptionPageViaBuilder'

const GAME_DESCRIPTION_PAGE_MODEL = process.env.ARCADE_DESCRIPTION

export function ArcadeGamesPageContainerClient({ page }: any) {
  if (!page.gameProduct) {
    notFound()
  }

  return (
    <GameIsAdminOnly gameLaunchDate={page.gameProduct.launchDate} showLoader>
      <GameDescriptionPageViaBuilder pageProps={page} pageModel={GAME_DESCRIPTION_PAGE_MODEL} />
    </GameIsAdminOnly>
  )
}
